import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { HostListener, Injectable } from '@angular/core';

import { CanDeactivate } from '@angular/router';
import { Location } from '@angular/common';
import { Observable } from 'rxjs/Observable';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';

@Injectable()
export abstract class CanComponentDeactivate {

  constructor(protected translateService: TranslateService) { }

  @HostListener('window:beforeunload', ['$event'])
  onDeactivate(event: any) {
    if (!environment.isDeactivateGuardEnabled || !this.hasPendingChanges()) {
      return;
    }

    let message = this.translateService.instant('PENDINGCHANGES.MESSAGE');
    if (event) {
      (event || window.event).returnValue = message; // Gecko + IE
    } else {
      const question = this.translateService.instant('PENDINGCHANGES.QUESTION');
      message = message + ' ' + question;
    }
    return message; // Gecko + Webkit, Safari, Chrome etc.
  }

  abstract hasPendingChanges(): boolean;
}

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {

  constructor(private router: Router, private location: Location) { }

  canDeactivate(component: CanComponentDeactivate, route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | boolean {
    const message = component.onDeactivate(null);
    if (message) {
      const wantToDeactivate = confirm(message);
      if (!wantToDeactivate) {
        this.location.go(state.url); // fix address bar
        return false;
      }
    }
    return true;
  }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/core/services/can-deactivate-guard.service.ts